import { motion } from "framer-motion";
import { Search, PenTool, Code2, Rocket } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS } from "@/data/content";

const ICONS = { Search, PenTool, Code2, Rocket };

export const Process = () => {
  return (
    <section id="processo" className="relative border-t border-[#1A1A20] bg-[#050505]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading number="04" label="Processo" title="Do briefing ao" accent="lançamento." />
          <Reveal delay={0.15}>
            <p className="max-w-md text-sm leading-relaxed text-zinc-500 sm:text-base">
              Um método claro, sem surpresas. Você acompanha cada etapa pela sua área do cliente e recebe
              tudo dentro do prazo combinado.
            </p>
          </Reveal>
        </div>

        <div className="relative mt-16">
          <motion.div
            aria-hidden="true"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            className="absolute left-0 top-[26px] hidden h-px w-full origin-left bg-gradient-to-r from-[#E50914] via-[#E50914]/60 to-[#22222A] lg:block"
          />
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
            {PROCESS.map((step, i) => {
              const Icon = ICONS[step.icon];
              return (
                <Reveal key={step.n} delay={i * 0.12}>
                  <div data-testid={`process-step-${step.n}`} className="group relative">
                    <div className="relative z-10 flex h-[52px] w-[52px] items-center justify-center rounded-full border border-[#E50914]/40 bg-[#050505] transition-all duration-500 group-hover:border-[#E50914] group-hover:shadow-[0_0_28px_rgba(229,9,20,0.35)]">
                      <Icon className="h-5 w-5 text-[#E50914]" />
                    </div>
                    <span className="pointer-events-none absolute -right-2 -top-6 font-display text-7xl font-extrabold leading-none text-[#F4F4F6]/[0.04] transition-colors duration-500 group-hover:text-[#E50914]/10">
                      {step.n}
                    </span>
                    <div className="mt-8">
                      <span className="font-mono-code text-[10px] uppercase tracking-[0.3em] text-[#E50914]">
                        Etapa {step.n} · {step.duration}
                      </span>
                      <h3 className="mt-3 font-display text-xl font-bold text-zinc-100">{step.title}</h3>
                      <p className="mt-3 text-sm leading-relaxed text-zinc-500">{step.text}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
